import { parse } from 'qs';
import url from 'url';
import { convertToRaw, ContentState, EditorState } from 'draft-js';
import draftToHTML from 'draftjs-to-html';
import HTMLToDraft from 'html-to-draftjs';
import request from 'superagent';
//
import { WEEK_DAYS, CLOUDINARY_UPLOAD_URL, CLOUDINARY_UPLOAD_PRESET } from './constants';

export function getLocationQuery(search) {
  return parse(url.parse(search).query);
}

export function hashToMap(arr) {
  if (!Array.isArray(arr) || arr.length === 0) return {};
  const hash = arr.reduce((acc, current) => {
    acc[current._id] = current;
    return acc;
  }, {});

  return hash;
}

export const draftToHtml = (editorState) =>
  draftToHTML(convertToRaw(editorState.getCurrentContent()));

export const htmlToDraft = (html) => {
  const contentBlock = HTMLToDraft(html);
  if (contentBlock) {
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    const editorState = EditorState.createWithContent(contentState);
    return editorState;
  }

  return null;
};

export const convertDayNumberToWeekDay = (dayNumber) => {
  if (typeof dayNumber !== 'number') return null;
  return WEEK_DAYS[dayNumber - 1];
};

export const validateTime = (time) => {
  const num = time.split(':');
  if (num.length !== 2) return false;
  if (num[0].length !== 2 || num[1].length !== 2) return false;
  const left = parseInt(num[0], 10);
  const right = parseInt(num[1], 10);
  if (left < 0 || left > 23) return false;
  if (right < 0 || right > 60) return false;
  return true;
};

export function getImageDimensions(file) {
  return new Promise(function (resolved) {
    const _URL = window.URL || window.webkitURL;
    const i = new Image();
    i.onload = function () {
      resolved({
        w: `${i.width}`,
        h: `${i.height}`,
      });
    };

    i.src = _URL.createObjectURL(file);
  });
}

export function copyTextToClipboard(value, cb) {
  try {
    // Create an auxiliary hidden input
    const aux = document.createElement('input');

    aux.setAttribute('value', value);
    // Append the aux input to the body
    document.body.appendChild(aux);
    // Highlight the content
    aux.select();
    // Execute the copy command
    document.execCommand('copy');
    // Remove the input from the body
    document.body.removeChild(aux);
    cb(true);
  } catch (e) {
    cb(false);
  }
}

export function copyToClipboard(elementId, cb) {
  const node = document.getElementById(elementId);
  const value = node.value;
  copyTextToClipboard(value, cb);
}

export function copyLinkToClipboardAsText(link, text, cb) {
  try {
    const anchor = document.createElement('a');
    anchor.href = link;
    anchor.innerText = text;
    document.body.appendChild(anchor);

    const range = document.createRange();
    range.selectNode(anchor);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand('copy');
    document.body.removeChild(anchor);

    cb(true);
  } catch (e) {
    cb(false);
  }
}

const REGEX_PATTERNS = {
  // https://stackoverflow.com/a/8829363
  email:
    // eslint-disable-next-line no-useless-escape
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  url: new RegExp(
    '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    'i'
  ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i,
};

export const standardizeEmail = (email = '') => {
  return email.toLowerCase().trim();
};

export const isValidEmail = (value) => {
  return typeof value === 'string' && !!value.match(REGEX_PATTERNS.email) && value.length < 255;
};

export const uploadToCloudinary = (file, preset) => {
  return request
    .post(CLOUDINARY_UPLOAD_URL)
    .field('upload_preset', preset || CLOUDINARY_UPLOAD_PRESET)
    .field('file', file);
};

export const getActiveTab = (search = '', tabs = []) => {
  if (!Array.isArray(tabs) || tabs.length === 0) {
    throw new Error('Non-empty tabs argument required.');
  }

  if (!search) return tabs[0];
  const qs = getLocationQuery(search);
  let activeTab = qs.tab || tabs[0];
  activeTab = tabs.indexOf(activeTab) !== -1 ? activeTab : tabs[0];
  return activeTab;
};

// SW-2306: This file is going away in favor of domain/concept-specific
// helper files. Please don't add new functions to this file.
